import axios from 'axios';
//import authHeader from './auth-header';
import { genConfig } from 'holiday-avatar';
import api from "./api";//Added 2024-04-10 for refreshToken
import TokenService from "./token.service";//Added 2024-04-10 for refreshToken

//const API_URL = 'http://localhost:8080/api/auth/';

class AuthService {
  /*login(user) {
    return axios*/
  //    .post(process.env.VUE_APP_ROOT_API /*API_URL*/ + 'auth/signin', {
  /*      username: user.username,
        password: user.password
      })
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem('user', JSON.stringify(response.data));
        }

        return response.data;
      });
  }*/
  //2024-04-10 Changed login for refreshToken
  login({ username, password }) {
    return api
      .post("/auth/signin", {
        username,
        password
      })
      .then((response) => {
        if (response.data.accessToken) {
          TokenService.setUser(response.data);
        }

        return response.data;
      });
  }

  /*logout() {
    localStorage.removeItem('user');
  }*/
  //2024-04-10 Changed login for refreshToken
  logout() {
    TokenService.removeUser();
  }

  /*register(user) {
    var userConfig = genConfig();*/

  //  return axios.post(process.env.VUE_APP_ROOT_API /*API_URL*/ + 'auth/signup', {
  /*    username: user.username,
      email: user.email,
      password: user.password,
      firstname: user.firstname,
      lastname: user.lastname,
      config: userConfig
    });
  }*/
  //2024-04-10 Changed register for refreshToken
  register(user/*{ username, email, password }*/) {
    var userConfig = genConfig();
    return api.post("/auth/signup", {
      /*username,
      email,
      password*/
      username: user.username,
      email: user.email,
      password: user.password,
      firstname: user.firstname,
      lastname: user.lastname,
      config: userConfig
    });
  }

  changePwd(data) {
    //return axios.put(process.env.VUE_APP_ROOT_API + 'auth/changepwd', data, { headers: authHeader() } ) //Replaced 2024-04-17 due to RefreshToken
    return api.put('auth/changepwd', data);
  }

  forgotPwd(data) {
    //return axios.put(process.env.VUE_APP_ROOT_API + 'auth/forgotpwd', data/*, { headers: authHeader() }*/) //Replaced 2024-04-17 due to RefreshToken
    return api.put('auth/forgotpwd', data);
  }

  resetPwd(data,resetToken) {
    // Use shared api instance so baseURL and interceptors (e.g. refresh token) apply consistently
    return api.put('/auth/resetpwd', data, { headers: { 'x-access-token': resetToken } })
  }

  confirmUser(confirmToken) {
    const data = {action: "confirmuser"};
    // Use shared api instance here as well
    return api.put('/auth/confirmuser', data, { headers: { 'x-access-token': confirmToken } })  
  }

}

export default new AuthService();